import { render } from "./Attach.vue?vue&type=template&id=73c963ec"
import script from "./Attach.vue?vue&type=script&lang=js"
export * from "./Attach.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Attach.vue"]])

export default __exports__